import React, { useState } from 'react'

import { Button } from 'component-library-next'

import { useCreateOrUpdateCustomerNoteMutation } from '@app/queries/CreateOrUpdateCustomerNote/CreateOrUpdateCustomerNote.queries'

type Props = {
  customerId: number
  note?: string
}

export default function LawyerNotes({ customerId, note: previousNote }: Props) {
  const [note, setNote] = useState<string>(previousNote || '')
  const [createOrUpdateCustomerNote] = useCreateOrUpdateCustomerNoteMutation()

  const sendNote = async () => {
    await createOrUpdateCustomerNote({
      variables: {
        customerId,
        note: note || ''
      }
    })
  }

  return (
    <div className='lawyer-notes'>
      <h4 className='subheading-text'>Aktennotiz</h4>

      <textarea
        value={note}
        placeholder='Klicken Sie hier um Text einzugeben.'
        onChange={(e) => setNote(e.target.value)}
      />

      <div className='btn-wrap'>
        <Button onClick={sendNote}>Speichern</Button>
      </div>
    </div>
  )
}
